import React, { Component } from 'react';
import { Link } from "react-router-dom";
import SitesSelect from '../../common/SitesSelect'
import AccountTypesSelect from '../../common/AccountTypesSelect'
import { HttpRequestService } from '../../services/HttpRequestService';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import CompanySelect from '../../common/CompanySelect';
import StateSelect from '../../common/StateSelect';
import Checkbox from '../../common/Checkbox';
import Report from '../../common/Report';

class InvoiceReport extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            beginDate: moment(new Date()).toDate(),
            endDate: moment(new Date()).toDate(),
            companyId: -1,
            accountTypeId: -1,
            stateId: -1,
            siteId: -1,
            groupBy: "AccountType",
            customerNumber: '',
            onlyOrdersWithSalesTax: false,
            onlyOrdersWithTransactionId: false,
            report: null,
        }
        this.sortBy = "";
        this.sortDirection = "";
        this.paramsKey = "params.invoice-report";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();
        this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.handleAccountTypeChange = this.handleAccountTypeChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleSiteChange = this.handleSiteChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleOnlyOrdersWithSalesTaxChange = this.handleOnlyOrdersWithSalesTaxChange.bind(this);
        this.handleOnlyOrdersWithTransactionIdChange = this.handleOnlyOrdersWithTransactionIdChange.bind(this);
        this.handleCustomerNumberChange = this.handleCustomerNumberChange.bind(this);
        this.getReport = this.getReport.bind(this);
        this.sortReport = this.sortReport.bind(this);
    }

    componentDidMount() {
        this.getReport();
    }

    handleBeginDateChange(e) {
        this.setState({ beginDate: e });
    }

    handleEndDateChange(e) {
        this.setState({ endDate: e });
    }

    handleCompanyChange(companyId) {
        this.setState({ companyId: companyId });
    }

    handleAccountTypeChange(accountTypeId) {
        this.setState({ accountTypeId: accountTypeId });
    }

    handleStateChange(state) {
        this.setState({ stateId: state.stateID });
    }

    handleSiteChange(siteId) {
        this.setState({ siteId: siteId });
    }

    handleGroupByChange(e) {
        this.setState({ groupBy: e.target.value });
    }

    handleCustomerNumberChange(e) {
        this.setState({ customerNumber: e.target.value });
    }

    handleOnlyOrdersWithSalesTaxChange(checked) {
        this.setState({ onlyOrdersWithSalesTax: checked });
    }

    handleOnlyOrdersWithTransactionIdChange(checked) {
        this.setState({ onlyOrdersWithTransactionId: checked });
    }

    getPrintPDFUrl(type, order) {
        return this.http.HOST + "/Print/Order?type=" + type + "&OrderID=" + order.orderID + "&OrderNumber=" + order.orderNumber;
    }

    getReport(e) {
        if (!!e) {
            e.preventDefault();
        }
        var params = {
            beginDate: this.state.beginDate != null ? moment(this.state.beginDate).format('L') : "",
            endDate: this.state.endDate != null ? moment(this.state.endDate).format('L') : "",
            companyId: this.state.companyId,
            accountTypeId: this.state.accountTypeId,
            stateId: this.state.stateId,
            siteId: this.state.siteId,
            groupBy: this.state.groupBy,
            customerNumber: this.state.customerNumber,
            onlyOrdersWithSalesTax: this.state.onlyOrdersWithSalesTax,
            onlyOrdersWithTransactionId: this.state.onlyOrdersWithTransactionId,
            sortBy: this.sortBy,
            sortDirection: this.sortDirection
        }

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Report/GetInvoiceReport', params).then(data => {
            this.setState({ report: data });
        });
    }

    sortReport(field) {
        if (this.sortBy !== field) {
            this.sortDirection = "ASC";
        }
        else {
            if (this.sortDirection === "ASC") {
                this.sortDirection = "DESC";
            }
            else {
                this.sortDirection = "ASC";
            }
        }
        this.sortBy = field;
        this.getReport();
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Invoice Report</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={this.getReport}>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="beginDate">Invoices From</label>
                                            <DatePicker className="form-control" selected={this.state.beginDate} onChange={this.handleBeginDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="endDate">Invoices To</label>
                                            <DatePicker className="form-control" selected={this.state.endDate} onChange={this.handleEndDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="orderStatus">Company</label>
                                            <CompanySelect value={this.state.companyId} onChange={this.handleCompanyChange} hasAllOption={true}></CompanySelect>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label>Account Type</label>
                                            <AccountTypesSelect value={this.state.accountTypeId} onChange={this.handleAccountTypeChange} hasAllOption={true}></AccountTypesSelect>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>State</label>
                                            <StateSelect countryID={211} value={this.state.stateId} onChange={this.handleStateChange} hasAllOption={true}></StateSelect>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Site</label>
                                            <SitesSelect value={this.state.siteId} onChange={this.handleSiteChange} hasAllOption={true}></SitesSelect>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Group By</label>
                                            <select className="form-control" value={this.state.groupBy} onChange={this.handleGroupByChange}>
                                                <option value="AccountType">Account Type</option>
                                                <option value="State">State</option>
                                                <option value="Site">Site</option>
                                                <option value="Company">Company</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label>Specific Customer #</label>
                                            <input type="text" className="form-control" value={this.state.customerNumber} onChange={this.handleCustomerNumberChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>&nbsp;</label>
                                            <Checkbox label="Only Orders with Sales Tax?" checked={this.state.onlyOrdersWithSalesTax} onChange={this.handleOnlyOrdersWithSalesTaxChange}></Checkbox>
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>&nbsp;</label>
                                            <Checkbox label="Only Auth.Net Orders?" checked={this.state.onlyOrdersWithTransactionId} onChange={this.handleOnlyOrdersWithTransactionIdChange}></Checkbox>
                                        </div>
                                    </div>
                                    <div className="form-row justify-content-end">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {this.state.report != null &&
                            <Report name="InvoiceReport" hasData={this.state.report.items && this.state.report.items.length > 0} title="Invoice Report" description={this.state.report.description}>
                                <div className="form-row">
                                    <table className="table table-striped mt-1 report-table">
                                        {this.state.report.items.map((group) =>
                                            <React.Fragment key={group.name}>
                                                <thead>
                                                    <tr className="bg-primary reportHeader">
                                                        <th colSpan={13}>{group.name}</th>
                                                    </tr>
                                                    <tr>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("OrderNumber")}>INV #</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("CustPO")}>PO #</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("TransactionID")}>TRANSACTION ID</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("FulfillDate")}>INV DATE</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("CustomerNumber")}>CUST #</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("CompanyName")}>CUSTOMER</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("TypeAbbr")}>TYPE</th>
                                                        <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("SubTotal")}>SALES</th>
                                                        <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("ShipCost")}>S/H</th>
                                                        <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("Discount")}>DISCOUNT</th>
                                                        <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("Total")}>INV TOTAL</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("OrderStatusDesc")}>STATUS</th>
                                                        <th className="sortable" scope="col" onClick={(e) => this.sortReport("StateAbbreviation")}>STATE</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {group.items && group.items.map(item =>
                                                        <tr key={item.orderID}>
                                                            <td><a href={this.getPrintPDFUrl("Invoice", item)} target="_blank" rel="noopener noreferrer">{item.orderNumber}</a></td>
                                                            <td>{item.custPO}</td>
                                                            <td>{item.transactionID}</td>
                                                            <td>{moment(item.fulfillDate).format('l')}</td>
                                                            <td><Link to={"/customer/" + item.customerID}>{item.customerNumber}</Link></td>
                                                            <td>{item.companyName}</td>
                                                            <td>{item.typeAbbr}</td>
                                                            <td className="currency">{this.utils.toCurrency(item.subTotal, item.currencyCode)}</td>
                                                            <td className="currency">{this.utils.toCurrency(item.shipCost, item.currencyCode)}</td>
                                                            <td className="currency">{this.utils.toCurrency(item.discount, item.currencyCode)}</td>
                                                            <td className="currency">{this.utils.toCurrency(item.total, item.currencyCode)}</td>
                                                            <td>{item.orderStatusDesc}</td>
                                                            <td>{item.stateAbbreviation}</td>
                                                        </tr>
                                                    )}
                                                    {group.sales.map((s, i) =>
                                                        <tr className="bg-light reportFooter">
                                                            <th colSpan={4}>
                                                                {i === 0 &&
                                                                    <span>
                                                                        TOTAL # of INVOICES
                                                                    </span>
                                                                }
                                                            </th>
                                                            <th>{group.currencyItemCounts[s.currency.toLowerCase()]}</th>
                                                            <th></th>
                                                            <th></th>
                                                            <th className="currency">{this.utils.toCurrency(s.amount, s.currency)}</th>
                                                            <th className="currency">{this.utils.toCurrency(group.shipping[i].amount, group.shipping[i].currency)}</th>
                                                            <th className="currency">{this.utils.toCurrency(group.discount[i].amount, group.discount[i].currency)}</th>
                                                            <th className="currency">{this.utils.toCurrency(group.total[i].amount, group.total[i].currency)}</th>
                                                            <th></th>
                                                            <th></th>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </React.Fragment>
                                        )}
                                        <tbody>
                                            {this.state.report.sales.map((s, i) =>
                                                <tr className="bg-dark reportFooter">
                                                    <th colSpan={4}>
                                                        {i === 0 &&
                                                            <span>
                                                                TOTAL # of INVOICES
                                                            </span>
                                                        }
                                                    </th>
                                                    <th><th>{this.state.report.currencyItemCounts[s.currency.toLowerCase()]}</th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th className="currency">{this.utils.toCurrency(s.amount, s.currency)}</th>
                                                    <th className="currency">{this.utils.toCurrency(this.state.report.shipping[i].amount, this.state.report.shipping[i].currency)}</th>
                                                    <th className="currency">{this.utils.toCurrency(this.state.report.discount[i].amount, this.state.report.discount[i].currency)}</th>
                                                    <th className="currency">{this.utils.toCurrency(this.state.report.total[i].amount, this.state.report.total[i].currency)}</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table>
                                </div>
                            </Report>
                        }
                    </div>
                </div>
            </div >
        );
    }
}

export default InvoiceReport;
